/** @format */

export const countryModelModule = 'sis-components.model.country';
'use strict';
(function () {
  countryJSDataModel.$inject = ["DS", "$http"];
  angular.module(countryModelModule, ['js-data']).factory('countryJSDataModel', countryJSDataModel);

  /**
   * @ngInject
   */
  function countryJSDataModel(DS, $http) {
    var ENDPOINT = '/kori/api/cached/codebooks/urn:code:country';
    var model = DS.defineResource({
      idAttribute: 'urn',
      name: 'country'
    });
    model.lazyGetAll = _.once(function () {
      return $http.get(ENDPOINT).then(function (response) {
        model.inject(_.values(response.data));
        return model.getAll();
      });
    });
    model.lazyGet = function (relJSDataModel, def, instance, orig) {
      // JSDataModel first first return undefined, and when lazyGetAll has initialized the model, the value will change
      // to the actual value by angular watch.
      //
      // Onetime binding works, as there will be a watch as long as the value is undefined
      model.lazyGetAll();
      return orig();
    };
    return model;
  }
})();